import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";
import { reverse } from "utils/urls";

import Loading from "components/Loading";

import { useSignedUser } from "entities/Auth/sdk";

const DefaultAddress = () => {
  const { data: user } = useSignedUser();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const nextUrl = searchParams.get("next");

    if (!_.isNil(nextUrl)) {
      const currentUrl = new URL(window.location.href);
      const baseUrl = currentUrl.origin;

      const [, pathname] = nextUrl.split(baseUrl);

      if (!_.isEmpty(pathname)) {
        navigate(pathname);
        return;
      }
    }

    if (_.isNil(user)) {
      return;
    }

    if (user.company_is_paying_customer) {
      navigate(reverse(URLS.PROJECTS_LIST, { phase: "All" }));
    } else {
      navigate(URLS.COLLABORATOR_DASHBOARD);
    }
  }, [navigate, user?.company_is_paying_customer, searchParams, user]);

  return <Loading open />;
};

export default DefaultAddress;
